import React from 'react';

import styles from '../../../../pages/ClubProfiles/club.scss';

const Metric = (props) => {
    return (
        <div className={`${styles.metric}`}>
            <div className={`${styles.metricValue} show-ellipsis`}>
                {props.value}
            </div>
            <hr className={`mt8 mb4`} />
            <div className={`${styles.metricName} show-ellipsis`}>
                {props.name}
            </div>
        </div>
    );
};

export default Metric;
